import useAnamNudgytAgentClient from '../../hooks/useAnamNudgytAgentClient';

function AnamNudgytAgentClient({
  aiResponsePlaybackActiveRef,
  isVideoStreamReady,
  handleSendAudioChunk,
  handleEndAudioSequence
}) {
  useAnamNudgytAgentClient({
    aiResponsePlaybackActiveRef,
    isVideoStreamReady,
    handleSendAudioChunk,
    handleEndAudioSequence
  });

  return null;
}

export default AnamNudgytAgentClient;
